import { ReactNode } from 'react'
import { NotificationPanel } from './NotificationPanel'

interface PageHeaderProps {
  title: string
  subtitle?: string
  actions?: ReactNode
  children?: ReactNode
}

export function PageHeader({ title, subtitle, actions, children }: PageHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h1>
          {subtitle && (
            <p className="text-sm sm:text-base text-gray-600 mt-1 sm:mt-2">{subtitle}</p>
          )}
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          {actions}
          <NotificationPanel />
        </div>
      </div>
      {children}
    </div>
  )
}
